import type { NestedKeyOf } from '@lib/types/ts'
import { get } from 'lodash-es'

export const sortCollectionByString = <T>(rowA: T, rowB: T, property: NestedKeyOf<T>) => {
  const valueA = String(get(rowA, property) ?? '').toLowerCase()
  const valueB = String(get(rowB, property) ?? '').toLowerCase()

  if (valueA === valueB) {
    return 0
  } else if (valueA === '') {
    return 1
  } else if (valueB === '') {
    return -1
  }
  return valueA < valueB ? -1 : 1
}

/*
 * The array must be already sorted
 */
export function insertItemSorted<T>(
  array: ReadonlyArray<T>,
  item: T,
  compareFn: (a: T, b: T) => number,
): ReadonlyArray<T> {
  const index = array.findIndex((currentItem) => compareFn(item, currentItem) <= 0)
  if (index >= 0) {
    return [...array.slice(0, index), item, ...array.slice(index)]
  } else {
    return [...array, item]
  }
}

/*
 * Will return the indexes of the extra items (if any) that are on arrA only
 */
export function getExcessItemsIndexes(arrA: any[], arrB: any[]): number[] {
  const excessCount = arrA.length - arrB.length
  if (excessCount <= 0) return []
  return Array.from({ length: excessCount }, (_, i) => i + arrB.length)
}
